import { AveragePlayerScore } from '__generated__/globalTypes';

const totalAveragePlayerScoresArr = [
  AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE,
  AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
  AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE,
  AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE,
  AveragePlayerScore.SEASON_AVERAGE_SCORE,
];

export type TotalAveragePlayerScore =
  (typeof totalAveragePlayerScoresArr)[number];

export const isTotalAveragePlayerScore = (
  score: any
): score is TotalAveragePlayerScore => {
  return totalAveragePlayerScoresArr.includes(score);
};

export const averageScoreCount = {
  [AveragePlayerScore.LAST_FORTY_SO5_AVERAGE_SCORE]: 40,
  [AveragePlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE]: 15,
  [AveragePlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE]: 10,
  [AveragePlayerScore.LAST_FIVE_SO5_AVERAGE_SCORE]: 5,
  [AveragePlayerScore.SEASON_AVERAGE_SCORE]: null,
};
